export function replacePathUsername(previousUrl, username) {
  const regex = /(http.*:\/\/[^/]+)\/(.+)/gm;
  const str = `${previousUrl}`;
  const subst = `$1/${username}`;

  return str.replace(regex, subst);
}
